<script setup lang="ts">
	import { ref } from "vue";
	import SectionFooter from "~/components/sections/sectionFooter.vue";
	import SectionHeader from "~/components/sections/sectionHeader.vue";
	import SectionUserAccountTimeOut from "~/components/sections/sectionUserAccountTimeOut.vue";
	import { useAuthStore } from "~/store/auth";
	import { isTimeOutStartEnd } from "~/utils";
	const isUserLogin = ref(false);
	isUserLogin.value = !!useAuthStore().user;
	// useHead({
	// 	titleTemplate: (titleChunk) => {
	// 		return titleChunk ? `${titleChunk} - Sedna` : "Sedna";
	// 	},
	// });

	const route = useRoute();
	const authStore = useAuthStore();

	const isTimeOut = computed(() => {
		if (!authStore.user) return false;
		if (!authStore.userAccount) return false;
		if (authStore.userAccount.is_default_account) return false;
		if (!authStore.hasPin()) return false;
		if (
			!authStore.user.watch_limit_start_hour ||
			!authStore.user.watch_limit_end_hour
		)
			return false;
		return isTimeOutStartEnd(
			authStore.user?.watch_limit_start_hour,
			authStore.user?.watch_limit_end_hour,
		);
	});
</script>

<template>
	<div>
		<div v-if="!(isTimeOut && route.path != '/panel/accounts')">
			<header class="text-black sticky top-0 z-50">
				<ClientOnly>
					<section-header />
				</ClientOnly>
			</header>

			<!-- Main -->
			<main>
				<slot :key="isUserLogin"></slot>
			</main>
			<footer
				class="px-6 sm:px-6 lg:px-20 bg-dark flex justify-center items-center text-white py-1 w-full"
				dir="rtl"
			>
				<section-footer></section-footer>
			</footer>
		</div>
		<section-user-account-time-out v-else> </section-user-account-time-out>
	</div>
</template>
